<template>
  <div class="creditcard">
    <v-app>
      <div v-if="!loadingPageProfile">
        <div v-if="!userid">
          <v-container>
            <v-alert :value="true" color="warning" icon="priority_high" outline>
              {{ $t("Not found this page") }}
            </v-alert>
          </v-container>
        </div>
        <div v-else-if="!isPaypal">
          <v-container>
            <v-alert :value="true" color="warning" icon="priority_high" outline>
              {{ $t("Not yet installed to accept credit cards") }}
            </v-alert>
          </v-container>
        </div>
        <div v-else-if="isCompleted">
          <cover>
            <div slot="body" style="text-align: center;margin-top: -95px;">
              <img
                src="../assets/img/ecommerce/shopping_cart@4x.png"
                alt="shopping cart"
                style="width: 140px;padding-bottom: 10px;"
              />
              <p style="padding-bottom: 10px">{{ $t("Payment Successfully") }}</p>
              <v-btn outline :color="theme.color" @click="goToShop()">
                {{ $t("Continue Shopping") }}
              </v-btn>
            </div>
          </cover>
        </div>
        <div v-else-if="isEmptyShoppingCart">
          <cover>
            <div slot="body" style="text-align: center;margin-top: -95px;">
              <img
                src="../assets/img/ecommerce/shopping_cart_out@4x.png"
                alt="empty shopping cart"
                style="width: 140px;padding-bottom: 10px;"
              />
              <p style="padding-bottom: 10px">
                {{ $t("This order has been reset, please try to order again.") }}
              </p>

              <v-btn outline :color="theme.color" @click="goToShop()">
                {{ $t("Continue Shopping") }}
              </v-btn>
            </div>
          </cover>
        </div>
        <!-- <div v-else-if="isCartOutOfStock">
        <cover>
          <div slot="body" style="text-align: center;margin-top: -95px;">
            <img
              src="../assets/img/ecommerce/empty_shopping_cart@4x.png"
              alt="empty shopping cart"
              style="width: 140px;padding-bottom: 10px;"
            />
            <p style="padding-bottom: 10px">{{$t('There are no items in this cart')}}</p>

            <v-btn outline :color="theme.color" @click="goToShop()">{{$t('Continue Shopping')}}</v-btn>
          </div>
        </cover>
        </div>-->
        <!-- <div v-else-if="pageLoading" style="height: 100vh">
        <v-layout justify-center align-center style="height: 100%">
          <v-progress-circular
            :key="theme.color"
            :size="70"
            :width="7"
            :color="theme.color"
            indeterminate
          ></v-progress-circular>
        </v-layout>
        </div>-->
        <div v-else>
          <merchant-detail v-model="pageProfile"></merchant-detail>
          <form id="checkout-form" class="checkout-form" method="POST">
            <v-container>
              <v-layout wrap row class="mt-5">
                <v-flex xs12 sm6 offset-sm3>
                  <h3 class="headline" :style="{ color: theme.color }">{{ $t("Payment") }}</h3>
                  <br />
                </v-flex>
                <v-flex xs12 sm6 offset-sm3>
                  <div :class="{ 'has-error': errors.has('customerName') }" class="mb-1">
                    <v-text-field
                      :label="$t('Name')"
                      :data-vv-as="$t('Name')"
                      outline
                      name="customerName"
                      v-validate="'required'"
                      v-model="customerName"
                      light
                      :color="theme.color"
                      :error="errors.has('customerName') ? true : false"
                      :error-messages="
                        errors.has('customerName') ? errors.first('customerName') : ''
                      "
                    ></v-text-field>
                  </div>
                  <div :class="{ 'has-error': errors.has('shippingAddress') }" class="mb-1">
                    <v-textarea
                      outline
                      :label="$t('Shipping Address')"
                      name="shippingAddress"
                      rows="5"
                      :data-vv-as="$t('Shipping Address')"
                      style="resize: none;width:100%"
                      v-model="shippingAddress"
                      v-validate="'required'"
                      light
                      :color="theme.color"
                      :error="errors.has('shippingAddress') ? true : false"
                      :error-messages="
                        errors.has('shippingAddress') ? errors.first('shippingAddress') : ''
                      "
                    ></v-textarea>
                  </div>

                  <div :class="{ 'has-error': errors.has('customerPhone') }" class="mb-1">
                    <v-text-field
                      :label="$t('Tel.')"
                      :data-vv-as="$t('Tel.')"
                      outline
                      name="customerPhone"
                      light
                      :color="theme.color"
                      v-validate="{ required: true, regex: /^[+]?[0-9]{3,12}$/ }"
                      v-model="customerPhone"
                      :error="errors.has('customerPhone') ? true : false"
                      :error-messages="
                        errors.has('customerPhone') ? errors.first('customerPhone') : ''
                      "
                    ></v-text-field>
                  </div>

                  <template v-if="pageProfile && pageProfile.pageid && shippinglist">
                    <shipping-type
                      v-model="shippingType"
                      :shippinglist="shippinglist"
                      :additionalproduct_charge="additionalproduct_charge"
                      :pageid="pageProfile.pageid"
                      :total="totalincludediscount"
                    ></shipping-type>
                  </template>
                </v-flex>
              </v-layout>
            </v-container>
            <v-divider></v-divider>

            <v-container>
              <v-layout wrap row>
                <v-flex xs12 sm6 offset-sm3>
                  <cart-summary
                    :total="total"
                    :totalincludediscount="totalincludediscount"
                    :discount="discount"
                    :shippingType="shippingType"
                    :additionalproduct_charge="additionalproduct_charge"
                  ></cart-summary>

                  <div :class="{ 'has-error': errors.has('remark') }" style="margin-bottom: 15px;">
                    <v-textarea
                      outline
                      :label="$t('Remark')"
                      name="remark"
                      rows="5"
                      :data-vv-as="$t('Remark')"
                      style="resize: none;width:100%"
                      v-model="remark"
                      :color="theme.color"
                      light
                    ></v-textarea>
                  </div>

                  <div class="text-xs-center" style="padding-bottom: 25px">
                    <div style="padding-top:15px;padding-bottom:15px;">
                      <a
                        href="javascript:void(0);"
                        @click="openModal()"
                        style="color: rgb(169, 169, 169);"
                      >
                        {{ $t("By clicking PayPal ชำระเงิน, Ive read and") }}
                        <br />
                        {{ $t("agree to") }}
                        <span :style="{ color: theme.color }">
                          {{ $t("Terms & Condition & Refund Prolicy") }} </span
                        >.
                      </a>
                    </div>
                    <template v-if="loading">
                      <div class="text-xs-center my-3">
                        <v-progress-circular
                          :key="theme.color"
                          indeterminate
                          :color="theme.color"
                        ></v-progress-circular>
                      </div>
                    </template>
                    <template v-show="!loading">
                      <p class="text-xs-center" style="color: red;" v-if="isCartOutOfStock">
                        {{ $t("Not enough products in stock, please try to order again.") }}
                      </p>
                      <div v-show="!isCartOutOfStock && !pageLoading">
                        <div id="paypal-button"></div>
                      </div>
                    </template>
                    <!-- <button type="submit" class="btn btn-primary" :disabled="loading">Proceed Payment</button> -->
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </div>

        <term-and-condition v-if="showTerm" @close="close()"></term-and-condition>
      </div>
    </v-app>

    <Loading v-if="(!pageLoading && loading) || loadingPageProfile"></Loading>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import $ from "jquery";
import config from "@/config";
import axios from "axios";
import SyncLoader from "vue-spinner/src/SyncLoader.vue";
import Loading from "@/components/Loading.vue";
import Modal from "@/components/Modal.vue";
import Cover from "@/components/Cover.vue";
import MerchantDetail from "@/components/ecommerce/MerchantDetail.vue";
import TermAndCondition from "@/components/ecommerce/TermAndCondition.vue";
import CartItem from "@/components/payment/CartItem.vue";
import ShippingType from "@/components/ecommerce/ShippingType.vue";
import CartSummary from "@/components/ecommerce/CartSummary.vue";

export default {
  data() {
    return {
      app: "facebook",
      environment: "production",
      pageid: undefined,
      userid: undefined,
      remark: "",

      additionalproduct_charge: 0,
      ems_charge: 0,
      normal_charge: 0,
      kerry_charge: 0,
      total: 0,
      totalincludediscount: 0,
      discount: 0,

      shippingType: undefined,

      loading: false,
      pageLoading: true,

      isPaypal: true,
      isCompleted: false,
      isEmptyShoppingCart: false,

      shippingAddress: null,

      cardInformation: {
        name: null,
        number: null,
        expiration_month: null,
        expiration_year: null,
        security_code: null,
      },

      showAlert: false,
      showProduct: false,
      showTerm: false,

      config: {
        color: config.color,
      },

      sessiontoken: undefined,
      paypal_merchantid: undefined,

      paypal_actions: undefined,
      customerName: null,
      customerPhone: null,
      shippinglist: undefined,
      isCartOutOfStock: false,
    };
  },
  mounted: async function() {
    let vm = this;
    vm.loading = true;

    if (vm.$route.query.userid) {
      // https://shop.zwiz.ai/creditcard/361231620965547?userid=1473322349418358&pkey=&sessiontoken=kayzb6cnv4m10fmle5rd4pldircb6svtgdpayfe3si1xetgldi&paypal_merchantid=WX5F9KTAH2NHN&lang=th
      vm.userid = vm.$route.query.userid == "xxx" ? "1473322349418358" : vm.$route.query.userid;
    }

    if (vm.$route.query.app) {
      vm.app = vm.$route.query.app == "xxx" ? "facebook" : vm.$route.query.app;
    }

    if (vm.$route.query.sessiontoken) {
      vm.sessiontoken =
        vm.$route.query.sessiontoken == "xxx"
          ? "kayzb6cnv4m10fmle5rd4pldircb6svtgdpayfe3si1xetgldi"
          : vm.$route.query.sessiontoken;
    }

    if (vm.$route.query.paypal_merchantid) {
      vm.paypal_merchantid =
        vm.$route.query.userid == "xxx" ? "WX5F9KTAH2NHN" : vm.$route.query.paypal_merchantid;
    }

    if (
      !vm.paypal_merchantid ||
      vm.paypal_merchantid == null ||
      vm.paypal_merchantid == "" ||
      !vm.userid ||
      !vm.pagename
    ) {
      vm.isPaypal = false;
    } else {
      vm.pageLoading = true;
      await vm.$store.dispatch("loadPageProfile", vm.pagename);
      vm.pageid = vm.pageProfile.pageid;
      document.title = vm.pageProfile.pagename;
      vm.$store.dispatch("updateShopColor", vm.pageProfile.shopcolor);
      vm.pageLoading = false;
      if (vm.userid) {
        // var response_lang = await vm.$store.dispatch("getUserShopLang", {
        //   pageid: vm.pageProfile.pageid,
        //   userid: vm.userid,
        // });
        vm.$store.dispatch("setLang", vm.pageProfile.shoplang);
        // if (response_lang) {
        // }

        vm.getUserDetail().then(function(data) {
          vm.customerName = data.name;
          vm.customerPhone = data.phone;
          vm.shippingAddress = data.address;
        });
      }
      // var data = {
      //   userid: vm.userid,
      //   pageid: vm.pageProfile.pageid,
      //   lang: vm.currentLang
      // };

      // vm.$store.dispatch("updatePageProfile", data);
      if (vm.pageProfile.wholesale_status === true) {
        vm.$store.dispatch("getWholeSale", vm.pageProfile.pageid);
      }
      // vm.$store.dispatch("getWholeSaleStatus", vm.pageProfile.pageid).then(function() {
      // });

      await vm.getProducts();
      vm.getUserCart(function() {
        vm.renderPaypalBtn();
      });

      var isCartOutOfStock =
        this.cart.filter(function(el) {
          if (el.optionDetail == null) {
            return true;
          }
          if (parseInt(el.optionDetail[2]) < el.quantity) {
            return true;
          }
          return false;
        }).length > 0;
      this.isCartOutOfStock = isCartOutOfStock;
      if (isCartOutOfStock) {
        await this.$swal({
          title: this.$t("Not enough products in stock"),
          text: this.$t("Please try to order again or contact Admin"),
          type: "warning",
          confirmButtonText: this.$t("Confirm"),
          cancelButtonText: this.$t("Cancel"),
          reverseButtons: true,
        });

        if (this.$liff.isInClient()) {
          // eslint-disable-next-line no-undef
          await this.$liff.sendMessages([
            {
              type: "text",
              text:
                this.$t("Not enough products in stock") +
                ", " +
                this.$t("Please try to order again or contact Admin"),
            },
          ]);
          // eslint-disable-next-line no-undef
          // await this.$liff.closeWindow();
        }
      }
      vm.loading = false;
    }
  },
  components: {
    SyncLoader,
    Loading,
    Modal,
    Cover,
    MerchantDetail,
    TermAndCondition,
    CartItem,
    ShippingType,
    CartSummary,
  },
  computed: {
    ...mapGetters({
      cart: "getCart",
      currentLang: "currentLang",
      loadingPageProfile: "getLoadingPageProfile",
      pageProfile: "getPageProfile",
      theme: "getTheme",
    }),
    pagename: function() {
      if (this.$route.params.id && this.$route.params.id == "xxx") {
        return "361231620965547";
      }
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined;
    },
    totalPrice: function() {
      if (this.shippingType) {
        return this.totalincludediscount + this.shippingType.value + this.additionalproduct_charge;
      } else {
        return this.totalincludediscount + this.additionalproduct_charge;
      }
    },
    optionExpirationYear: function() {
      let years = [];
      let today = new Date();
      let currentYear = today.getFullYear();
      for (let y = 0; y <= 10; y++) {
        years.push(currentYear + y);
      }
      return years;
    },
    // isCartOutOfStock: function() {
    //   return (
    //     this.cart.filter(function(el) {
    //       if (el.optionDetail == null) {
    //         return true;
    //       }
    //       if (parseInt(el.optionDetail[2]) < el.quantity) {
    //         return true;
    //       }
    //       return false;
    //     }).length > 0
    //   );
    // },
  },
  methods: {
    getUserDetail: function() {
      let vm = this;
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig("serverUrl") +
              "lastorderaddress?pageid=" +
              vm.pageid +
              "&userid=" +
              vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data;
            if (response.responsecode == 200) {
              if (response.data) {
                resolve(response.data);
              } else {
                reject();
              }
            } else {
              reject();
              // console.log(response);
            }
          });
      });
    },
    openModal: function() {
      this.showTerm = true;
      let vm = this;
      window.location.hash = "#modal-open";
      window.onpopstate = function(event) {
        if (location.hash == "#modal-open") {
          // console.log("test");
        } else {
          vm.showTerm = false;
        }
      };
    },
    close: function() {
      var vm = this;
      if (window.history.length == 0) {
        vm.showTerm = false;
      } else {
        window.history.back();
      }
    },
    getUserCart: function(callback) {
      let vm = this;
      axios
        .get(
          config.getConfig("serverUrl") + "usercart?pageid=" + vm.pageid + "&userid=" + vm.userid
        )
        .then((response) => {
          // JSON responses are automatically parsed.
          response = response.data;
          if (response.responsecode == 200) {
            // vm.$store.dispatch('setCart',response.cartarray)
            if (response.cartarray) {
              if (response.cartarray.length == 0) {
                vm.isEmptyShoppingCart = true;
              } else {
                vm.isEmptyShoppingCart = false;
              }
              var product_id_list = [];
              var products = [];
              $.each(response.cartarray, function(index, val) {
                product_id_list.push(val.productid);
                if (vm.products[val.productid]) {
                  var stock = vm.products[val.productid].productstock;
                  var option = stock.find(function(el) {
                    return el[1] == val.option;
                  });
                }
                products.push({
                  photourl: val.photourl,
                  quantity: val.quantity,
                  name: val.name,
                  option: val.option,
                  id: val.productid,
                  price: parseFloat(val.price),
                  discountprice: parseFloat(val.discountprice),
                  optionDetail: option,
                  categoryid: val.categoryid,
                  cart_remark: val.cart_remark,
                });
              });

              if (products.length > 0) {
                let url =
                  config.getConfig("serverUrl") +
                  "productbundle?productid=" +
                  product_id_list.join(",");
                axios.get(url).then((response) => {
                  response = response.data;
                  if (response.responsecode == 200) {
                    var allproductbundle = response.productbundlelist;
                    $.each(products, function(index, product) {
                      var p = product;
                      var bundles = [];
                      $.each(allproductbundle, function(bindex, bundle) {
                        if (bundle.productid == p.id) {
                          bundles.push(bundle);
                        }
                      });

                      p.productbundle = bundles;

                      vm.$store.dispatch("addToCart", p);
                    });
                  }
                });
              }

              vm.additionalproduct_charge = parseFloat(response.additionalproduct_charge);
              vm.ems_charge = parseFloat(response.ems_charge);
              vm.normal_charge = parseFloat(response.normal_charge);
              vm.kerry_charge = parseFloat(response.kerry_charge);
              vm.total = parseFloat(response.total);
              vm.totalincludediscount = parseFloat(response.totalincludediscount);
              vm.discount = parseFloat(response.discount);

              vm.shippinglist = response.shippinglist;
              callback();
            }
          } else {
            // console.log(response);
          }
        });
    },
    goToShop: function() {
      let vm = this;
      let url = "/ecommerce/" + vm.pagename;
      if (vm.userid && vm.userid != null && vm.userid != "") {
        url += "?userid=" + vm.userid;
        if (vm.sessiontoken && vm.sessiontoken != null && vm.sessiontoken != "") {
          url += "&sessiontoken=" + vm.sessiontoken;
        }
      }
      vm.$router.push({ path: url });
    },
    renderPaypalBtn: function() {
      var vm = this;
      var SERVER = "https://zwizai.herokuapp.com";
      // eslint-disable-next-line no-undef
      var lang = "";
      if (vm.currentLang == "th") {
        lang = "th_TH";
      } else if (vm.currentLang == "la") {
        lang = "en_LA";
      } else {
        lang = "en_US";
      }
      this.$loadScript("https://www.paypalobjects.com/api/checkout.js")
        .then(() => {
          // Script is loaded, do something
          paypal.Button.render(
            {
              locale: lang,
              env: vm.environment,

              validate: function(actions) {
                // console.log("validate");
                vm.paypal_actions = actions;
                vm.paypal_actions.disable();
                // console.log("validate", actions);
                vm.$validator.validate().then((result) => {
                  if (!result) {
                    // do stuff if not valid.
                    vm.paypal_actions.disable();
                    vm.goToErrorInput();
                    return false;
                  }
                  vm.paypal_actions.enable();
                });
              },
              onClick: function(data, actions) {
                // console.log("click", actions);
                if (vm.paypal_actions) {
                  // vm.paypal_actions.disable();
                  // console.log(vm.paypal_actions);
                  vm.$validator.validate().then((result) => {
                    if (!result) {
                      vm.goToErrorInput();
                      // do stuff if not valid.
                      vm.paypal_actions.disable();
                      // console.log("click error");
                      return false;
                    }
                    // console.log("click pass");
                    vm.paypal_actions.enable();
                  });
                }
              },
              payment: function(data, actions) {
                // console.log("payment", actions);
                return actions.request
                  .post(SERVER + "/merchant-api/create-payment/", {
                    amount: vm.totalPrice.toFixed(2).toString(),
                    pageid: vm.pageid,
                    userid: vm.userid,
                    paypal_merchantid: vm.paypal_merchantid,
                  })
                  .then(function(res) {
                    return res.id;
                  });
              },
              onAuthorize: function(data, actions) {
                // console.log("onAuthorize", actions);
                // console.log("ON AUTHORIZED");
                // console.log(data);
                // 2. Make a request to your server
                var total = vm.total + vm.additionalproduct_charge;
                if (vm.shippingType) {
                  total += vm.shippingType.value;
                }
                return actions.request
                  .post(SERVER + "/merchant-api/execute-payment/", {
                    paymentID: data.paymentID,
                    payerID: data.payerID,
                    amount: vm.totalPrice
                      .toFixed(2)
                      .toString()
                      .replace(".", ""),
                    pageid: vm.pageid,
                    paypal_merchantid: vm.paypal_merchantid,
                    userid: vm.userid,
                    app: vm.app,
                    nameaddress:
                      vm.customerName + " , " + vm.shippingAddress + " , " + vm.customerPhone,
                    name: vm.customerName,
                    address: vm.shippingAddress,
                    phone: vm.customerPhone,
                    shippingcharge: (
                      (vm.shippingType ? vm.shippingType.value : 0) + vm.additionalproduct_charge
                    )
                      .toFixed(2)
                      .toString()
                      .replace(".", ""),
                    remark: vm.$store.state.cds.includes(vm.pageid)
                      ? "หมายเลขเดอะวัน:" + vm.remark
                      : vm.remark,
                    total: total
                      .toFixed(2)
                      .toString()
                      .replace(".", ""),
                    shippingtype: vm.shippingType ? vm.shippingType.type : null,
                  })
                  .then(function() {
                    vm.isCompleted = true;
                    vm.$store.dispatch("deleteAllItemsInCart");
                    // eslint-disable-next-line
                    if (vm.$liff.isInClient()) {
                      // eslint-disable-next-line no-undef
                      vm.$liff.closeWindow();
                    } else if (vm.$route.query.app == "facebook") {
                      // eslint-disable-next-line no-undef
                      MessengerExtensions.requestCloseBrowser(
                        function success() {},
                        function error() {
                          window.close();
                        }
                      );
                    } else {
                      let url = "/ecommerce/" + vm.pagename;
                      if (vm.userid && vm.userid != null && vm.userid != "") {
                        url += "?userid=" + vm.userid;
                      }
                      vm.$router.push({ path: url });
                    }
                  });
              },
            },
            "#paypal-button"
          );
        })
        .catch(() => {
          // Failed to fetch script
        });
    },
    getProducts: function() {
      let vm = this;
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageid,
        };
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data["ketshop_api_key"] = vm.pageProfile.ketshop_api_key;
          data["ketshop_api_secret"] = vm.pageProfile.ketshop_api_secret;
        }
        axios
          .get(config.getConfig("serverUrl") + "products", {
            params: data,
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data;
            if (response.responsecode == 200) {
              vm.products = {};
              var products = response.productlist.filter((el) => {
                // console.log(el.status);
                return el.status == true;
              });
              $.each(products, function(index, val) {
                products[index].price = parseFloat(products[index].price);
                products[index].discountprice = parseFloat(products[index].discountprice);
                products[index].isOutOfStock = false;

                if (products[index].productstock.length > 0) {
                  var haveStock = false;
                  $.each(val.productstock, function(pindex, pval) {
                    if (parseInt(products[index].productstock[pindex][2]) > 0) {
                      haveStock = true;
                    }

                    var price = 0;
                    var discount = 0;

                    if (pval[3] == null && pval[4] == null) {
                      price = parseFloat(val.price);
                      discount = parseFloat(val.discountprice);
                    } else {
                      if (pval[3] == null) {
                        price = parseFloat(val.price);
                      } else {
                        price = parseFloat(products[index].productstock[pindex][3]);
                      }

                      if (pval[4] == null) {
                        discount = products[index].productstock[pindex][3];
                      } else {
                        discount = parseFloat(products[index].productstock[pindex][4]);
                      }
                    }

                    products[index].productstock[pindex][3] = price;

                    products[index].productstock[pindex][4] = discount;
                  });

                  if (!haveStock) {
                    products[index].isOutOfStock = true;
                  }
                } else {
                  products[index].isOutOfStock = true;
                }
                if (val) {
                  vm.products[val.id] = val;
                }
              });

              resolve();
            } else {
              // console.log(response);
              reject();
            }
          });
      });
    },
  },
  watch: {
    showTerm: function(newVal) {
      if (newVal) {
        $("body").addClass("modal-open");
      } else {
        $("body").removeClass("modal-open");
      }
    },
  },
};
</script>

<style scoped></style>
